export enum C3ProductVersionStatus {
    Draft = 'Draft',
    Released = 'Released',
    Obsolete = 'Obsolete'
}